import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { ForgotPassword, useForgotPwMutation } from '@centerpiece/components';

export const ForgotPasswordPage = () => {
  const navigate = useNavigate();
  const [reset] = useForgotPwMutation();

  return <ForgotPassword reset={reset} navigate={navigate} />;
};
